import { auth, db, functions } from '@/shared/services/firebase'
import axiosIns from '@hw-core/libs/axios'

export const fetchComment = async id => {
  try {
    const doc = await db.collection('comments').doc(id).get()

    if (!doc.exists) {
      throw new Error('No comment document found')
    }
    
    return {...doc.data(), id: doc.id}
  } catch (error) {
    return Promise.reject(error)
  }
}

export const addCommentToApplication = async ({ id, comment }) => {
  try {
    const token = await auth.currentUser.getIdToken(true)
    const response = await axiosIns.post(`${functions.url}/addCommentToApplication`, { id, comment, token })
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export const resolveApplicationComments = async ({id, processer}) => {
  try {
    const token = await auth.currentUser.getIdToken(true)
    const response = await axiosIns.post(`${functions.url}/resolveApplicationComments`, { id, processer, token })

    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}